<template>
    <!-- 자주하는 질문 다이올로그 -->
  <v-dialog v-model="bDialog" max-width="700px">
    <v-card>
      <div class="font-weight-bold d-flex pa-4 pb-2">
        <v-icon color="black" class="mr-2 pt-1 align-self-start">mdi-account-voice</v-icon>
        <div class="text-h6 font-weight-bold">
          {{DataItem.cFAQNm}}<br>
          <div class="text-subtitle-1 font-weight" style="line-height:140%">
            {{DataItem.cCreateDateTime.substring(0,19)}}<br>
            조회수 : {{DataItem.iShowCount}}
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn color="black darken-2" text @click="Close()" class="font-weight-bold text-subtitle-1 mt-n1 align-self-start">
          <v-icon class="mr-2">mdi-close</v-icon>닫기
        </v-btn>
      </div>

      <!-- <v-card-title class="font-weight-bold d-flex align-start">
        <v-icon :color="DataItem.color" class="mr-2 pt-2">{{DataItem.cIcon}}</v-icon>
        <div style="width:70%">{{DataItem.cFAQNm}}</div>
        <v-spacer></v-spacer>
        <v-btn color="black darken-2" text @click="Close()" class="font-weight-bold text-subtitle-1 mr-n4">
          <v-icon class="mr-2">mdi-close</v-icon>닫기
        </v-btn>
      </v-card-title>
      <div class="ml-14 mt-n3">
        {{DataItem.cCreateDateTime.substring(0,19)}}<br>
        조회수 : {{DataItem.iShowCount}}
      </div> -->

      <div style="height:150px;" class="pa-2 pr-4 pl-4">
        <editorRead
          style="padding:5px !important; width:100%; !important;"
          ref="QuillEditorRead"
          class="ql-editor"
          v-model="DataItem.cData"
        ></editorRead>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import EditorRead from "../views/EditorRead.vue";
import EventBus from "@/eventBus.js";

export default {
  components: {   
    EditorRead,          
  },

  data: () => ({ 
    bDialog: false,    

    DataItem: {
      cBannerNm: "",
      cCreateDateTime: "",
      cColor: "",
      cIcon: "",
      cData : "",
    },
    defaultDataItem: {
      cBannerNm: "",
      cCreateDateTime: "",
      cColor: "",
      cIcon: "",
      cData : "",
    },
  }),

  computed: {
  },


  created() {    
  },

  methods: {
    ShowDialog(BannerList) {
      this.bDialog = true;
      this.DataItem = BannerList;

      setTimeout(() => {
        try {
          this.$refs.QuillEditorRead.refresh(this.DataItem.cData);  
        } catch (error) {
          EventBus.$emit("onShowMsg", true,""+error);
        }  
      }, 100);
    },

    Close() {
      this.DataItem = Object.assign({}, this.defaultDataItem);
      this.bDialog = false;
    }
  }
};
</script>
